import { MetricName } from '@canvas/frontend-metrics';

import { type ApplicationModeIdentifier, type ApplicationMode } from '../types';

export const baseMode: ApplicationMode = {
  id: 'base' as ApplicationModeIdentifier,
  type: 'transitionable',
  observability: {
    tag: 'eap',
    load: MetricName.BOARD_LOAD,
  },
  awareness: {
    selections: {
      canSend: true,
      canConsume: true,
    },
    telepointer: {
      canSend: true,
      canConsume: true,
    },
    transient: {
      canSend: true,
      canConsume: true,
    },
  },
  updates: {
    canSend: true,
    canConsume: true,
  },
  policies: [],
  interface: {
    mainToolbar: { visible: true },
    navigation: { visible: true },
    metadataFooter: { visible: false },
    zoomToSelection: { visible: true },
  },
};
